import useAddress from '@/containers/SubscriptionFormPageNew/Components/Address/useAddress'
import {
  CreateAddressButton,
  CreateAddressButtonContainer,
} from '@/containers/SubscriptionFormPageNew/Components/Address/styled-components'

const AddAddressButton = () => {
  const { t, addressesList, updateActiveAddressHandler } = useAddress()

  if (!addressesList.length) {
    return null
  }

  return (
    <CreateAddressButtonContainer>
      <CreateAddressButton onClick={() => updateActiveAddressHandler('new')}>
        {t('subscriptionForm:address_v2.new_address_title')}
      </CreateAddressButton>
    </CreateAddressButtonContainer>
  )
}

export default AddAddressButton
